import p5 from "p5";
import { ServiceProvider } from ".";
import { registerMouseHandlers, registerTouchHandlers } from "../shared/mouseFunctions";
import { windowResized } from "../shared/utils";
import { keyPressed } from '../view/keyFunctions';

const s = (p) => {
    let provider;
    let drawErrorReported = false;

    p.setup = () => {
        try {
            provider = new ServiceProvider(p);
            provider.canvas = p.createCanvas(provider.p.windowWidth, provider.p.windowHeight);
            provider.canvas.style('display', 'block');

            provider.init();

            registerMouseHandlers(p, provider);
            registerTouchHandlers(p, provider);

            provider.view.reset();
        } catch (e) {
            window.posthog?.captureException(e);
            throw e;
        }
    };

    p.draw = () => {
        try {
            p.background(provider.backgroundColor);

            if (provider.settings.showImage
                && provider.image
                && provider.image.loaded
            ) {
                p.push();
                p.translate(provider.view.posX, provider.view.posY);
                provider.image.display(p);
                p.pop();
            }

            provider.grid.display(p);

            p.push();
            p.translate(provider.view.posX, provider.view.posY);

            provider.tools.currentTool.display(p);

            provider.elements.display(p);

            p.pop();

            provider.grid.displayLegend(p);
        } catch (e) {
            if (!drawErrorReported) {
                drawErrorReported = true;
                window.posthog?.captureException(e);
            }
        }
    };

    p.windowResized = () => {
        windowResized(provider);
    }

    p.keyPressed = () => {
        keyPressed(provider, p.keyCode);
    }
};
let planSketch = new p5(s, 'p5canvas');

export { s, planSketch };
